import { render, staticRenderFns } from "./add.vue?vue&type=template&id=77c45ea6&scoped=true"
import script from "./add.vue?vue&type=script&lang=ts"
export * from "./add.vue?vue&type=script&lang=ts"
import style0 from "./add.vue?vue&type=style&index=0&id=77c45ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c45ea6",
  null
  
)

export default component.exports